export default "query primaryActivities{\n    primaryActivities\n}";